import ConfirmationService from 'primevue/confirmationservice';
import ToastService from 'primevue/toastservice';
import FocusTrap from 'primevue/focustrap';
import ConfirmDialog from 'primevue/confirmdialog';
import Toast from 'primevue/toast';
import FloatLabel from 'primevue/floatlabel'
import Select from "primevue/select";
import Button from "primevue/button";
import InputGroupAddon from 'primevue/inputgroupaddon';
import InputText from 'primevue/inputtext'
import InputNumber from 'primevue/inputnumber'
import InputMask from 'primevue/inputmask'
import InputGroup from 'primevue/inputgroup';
import FileUpload from 'primevue/fileupload';
import Checkbox from 'primevue/checkbox';
import Password from 'primevue/password';
import Textarea from 'primevue/textarea'
import DatePicker from "primevue/datepicker";
import Image from 'primevue/image';
import Drawer from 'primevue/drawer';
import Divider from 'primevue/divider';
import Card from 'primevue/card';

export default {
  install(app) {
    app.component('ConfirmDialog', ConfirmDialog);
    app.component('Toast', Toast);
    app.component('FloatLabel', FloatLabel);
    app.component('Select', Select);
    app.component('Button', Button);
    app.component('InputGroupAddon', InputGroupAddon);
    app.component('InputText', InputText)
    app.component('InputMask', InputMask)
    app.component('InputNumber', InputNumber)
    app.component('InputGroup', InputGroup)
    app.component('FileUpload', FileUpload)
    app.component('Password', Password)
    app.component('Checkbox', Checkbox)
    app.component('Textarea', Textarea)
    app.component('DatePicker', DatePicker)
    app.component('Image', Image)
    app.component('Drawer', Drawer)
    app.component('Divider', Divider)
    app.component('Card', Card)

    app.use(ConfirmationService);
    app.use(ToastService);
    app.directive('focustrap', FocusTrap);

    app.config.globalProperties.$toastMessage = function (severity, summary, detail, life = 5000) {
        this.$toast.add({severity, summary, detail, life});
    };
  }
};
